export const getStoreGroups = state => state.GroupReducer.groups
export const getStoreTotal = state => state.StudentReducer.studentsCount